<div class="report-wrapper">
	<app-truck-report-header
		[currentSite]="currentSite"
		[device]="device"
		[selectedPeriod]="selectedPeriod"
		[data]="data"
	></app-truck-report-header>

	<div class="white-box main-black p-2 border-radius">
		<h3 class="h4 mb-4">{{'utilization.truck_performance_scores' | translate}}</h3>
		<app-truck-summary-report-performance [data]="data" [period]="selectedPeriod" [selectedDays]="selectedDays" [totalTrucks]="1"></app-truck-summary-report-performance>	
	</div>
	<div class="content">
		<div class="white-box main-black p-2 border-radius w-50">
			<h1 class="h4">{{'utilization.truck_usage_metrics' | translate}}</h1>
			<app-truck-fleet-usage-summary [data]="data" [period]="selectedPeriod" [selectedDays]="selectedDays" [showLegend]="false" [showFooterDate]="false" [forAnalytics]="true" [forDevice]="true"></app-truck-fleet-usage-summary>
		</div>

		<div class="white-box main-black p-2 border-radius w-50">
			<h1 class="h4">{{'utilization.truck_performance_metrics' | translate}}</h1>
			<app-truck-performance-metrics [data]="data" [period]="selectedPeriod" [selectedDays]="selectedDays" [device]="device"></app-truck-performance-metrics>
		</div>
	</div>
</div>

